import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useDashboardWelcome } from '@/composables/useDashboardWelcome'

/**
 * Records the donor's first dashboard visit via POST /me/dashboard-seen.
 * Called from the dashboard home route only, waits for GET /me before deciding.
 */
export function useMarkDashboardSeen() {
  const route = useRoute()
  const store = useStore()
  const { isWelcomeReady, dashboardSeenOnLoad } = useDashboardWelcome()

  onMounted(() => {
    if (route.meta.dashboardNav !== 'dashboard') return

    const markIfNeeded = () => {
      if (!isWelcomeReady.value || dashboardSeenOnLoad) return
      void store.dispatch('markDashboardSeen')
    }

    if (isWelcomeReady.value) {
      markIfNeeded()
      return
    }

    const stop = watch(isWelcomeReady, (ready) => {
      if (!ready) return
      stop()
      markIfNeeded()
    })
  })
}
